import { useMonarchRule } from "../MonarchRulesProvider";
import {
  SchoolRedesignData,
  SchoolRedesignVariant,
  SchoolRedesignTestResult,
  UseSchoolRedesign,
} from "./types";

const CUSTOM_RULE_ID = "schoolPageRedesign";

const useSchoolRedesign: UseSchoolRedesign = () => {
  const { isLoading, value } = useMonarchRule<{
    data: SchoolRedesignData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value) {
    return {
      isLoading,
      variant: "control",
    } as SchoolRedesignTestResult;
  }

  const { data } = value;
  const variant: SchoolRedesignVariant = data?.enabled ? "test" : "control";

  return {
    isLoading: false,
    variant,
    data,
  };
};

export default useSchoolRedesign;
